import { ProductDetails } from '@/modals/product-details';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrl: './product-view.component.scss'
})
export class ProductViewComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  productDetails: ProductDetails[] = [];
  getAllProductDetails: ProductDetails[] = [];
  searchText: any;
  productNameDetails: string[] = [];
  productCodeDetails: string[] = [];
  productCreationDateDetails: string[] = [];
  productCurrentStatus: string[] = [];
  productName: string = '';
  productCode: string = '';
  productCreationDate: string = '';
  productStatus: string = '';

  constructor(private appService: AppService, private toastr: ToastrService, private spinner: NgxSpinnerService,
    private datePipe: DatePipe, private router: Router) { }

  ngOnInit(): void {
    this.getProductDetails();
  }

  // get product details
  getProductDetails() {
    this.spinner.show();
    this.appService.getAllProducts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.getAllProductDetails = data.sort((a, b) => b.productId - a.productId);
        // get unique details for dropdowns  - productName, productCode, productCreationDate, productStatus
        this.productNameDetails = [...new Set(this.getAllProductDetails.map(item => item.productName))];
        this.productCodeDetails = [...new Set(this.getAllProductDetails.map(item => item.productCode))];
        this.productCreationDateDetails = [...new Set(this.getAllProductDetails.map(item => this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')))];
        this.productCurrentStatus = [...new Set(this.getAllProductDetails.map(item => item.availability))];
        this.productDetails = this.getAllProductDetails
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")
      });
  }


  // Current select filter value set function
  updateDetails(event: any, filterType: string) {
    // const value = event.target.value;

    // switch (filterType) {
    //   case 'name':
    //     this.productName = value !== 'Select Product Name' ? value : 'all';
    //     break;
    //   case 'commodity':
    //     this.productCode = value !== 'Select Product code' ? value : 'all';
    //     break;
    //   case 'date':
    //     this.productCreationDate = value !== 'Select Product Created Date' ? value : 'all';
    //     break;
    //   case 'date':
    //     this.productStatus = value !== 'Select Availability Status' ? value : 'all';
    //     break;

    //   default:
    //     break;
    // }

    // this.applyFilter();
  }

  // Apply filter function
  applyFilter() {
    // Start with the full dataset
    let filteredData = [...this.getAllProductDetails];

    // Apply product name filter
    if (this.productName && this.productName !== 'all') {
      filteredData = filteredData.filter(item => item.productName === this.productName);
    }

    // Update available options for product code and dates based on product name filter
    this.productCodeDetails = [...new Set(filteredData.map(item => item.productCode))];
    this.productCreationDateDetails = [...new Set(filteredData.map(item =>
      this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')
    ))];
    this.productCurrentStatus = [...new Set(filteredData.map(item => item.availability))]

    // Apply product code filter
    if (this.productCode && this.productCode !== 'all') {
      filteredData = filteredData.filter(item => item.productCode === this.productCode);
    }

    // Update available options for dates based on product code filter
    this.productCreationDateDetails = [...new Set(filteredData.map(item =>
      this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')
    ))];
    this.productCurrentStatus = [...new Set(filteredData.map(item => item.availability))]

    // Apply product add date filter
    if (this.productCreationDate && this.productCreationDate !== 'all') {
      filteredData = filteredData.filter(item =>
        this.datePipe.transform(item.createdAt, 'dd/MM/yyyy') === this.productCreationDate
      );
    }

    if (this.productStatus && this.productStatus !== 'all') {
      filteredData = filteredData.filter(item => item.availability === this.productStatus);
    }


    this.productDetails = filteredData;
  }



  // Remove filter function values
  resetReviewFilter() {
    this.searchText = '';
    this.productName = '';
    this.productCode = '';
    this.productCreationDate = '';
    this.productStatus = '';

    this.productDetails = [...this.getAllProductDetails];
    this.productNameDetails = [...new Set(this.productDetails.map(item => item.productName))];
    this.productCodeDetails = [...new Set(this.productDetails.map(item => item.productCode))];
    this.productCreationDateDetails = [...new Set(this.productDetails.map(item =>
      this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')
    ))];
    this.productCurrentStatus = [...new Set(this.productDetails.map(item => item.availability))];
  }

  selectCurrentStatusUpdate(item: any) {
    this.updateAlert(item);
  }


  updateAlert(item: any) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update the availability status",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, updated it!"
    }).then((result) => {
      if (result.isConfirmed) {
        // this.updateAvailabilityStatus(item);
      } else {
        window.location.reload();
      }
    });
  }

  EditAlert(item: any) {
    Swal.fire({
      title: "Are you sure?",
      html: `Are you sure you want to update the details of <b>${item.productName}</b>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel"
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("productId", item.productId);
        this.router.navigate(['/main/create']);
      } else {
        window.location.reload();
      }
    });
  }


  updateAvailabilityStatus(item: any) {
    // this.spinner.show();
    // const jsonData = {
    //   productId: item.productId,
    //   availability: item.availability
    // }
    // this.appService.updateProductAvailability(jsonData)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((data: any) => {
    //     this.toastr.success("Availability status updated successfully")
    //     setTimeout(() => {
    //       window.location.reload();
    //       this.spinner.hide();
    //     }, 1000);
    //   }, (error: any) => {
    //     this.spinner.hide();
    //     this.toastr.error(error.message || "Something went wrong, please try again...")
    //   })
  }

}
